"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTestimonialLink = exports.StyledTestimonial = exports.StyledTestimonialsWrapper = void 0;
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTestimonialsWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledTestimonialsWrapper", componentId: "sc-p9a5v2" }) `
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  ${(props) => (0, ui_1.mq)({
    rowGap: [props.theme.spacers.x3, props.theme.spacers.x6, props.theme.spacers.x9],
    columnGap: [props.theme.spacers.x3, props.theme.spacers.x10, '104px'],
})}
`;
exports.StyledTestimonial = styled_components_1.default.div.withConfig({ displayName: "StyledTestimonial", componentId: "sc-1bhht47" }) `
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacers.x2};
  justify-content: space-between;
  cursor: pointer;
  border-radius: ${(props) => props.theme.radii.primary};
  background-color: ${(props) => props.theme.colors.white};
  text-decoration: none;
  color: ${(props) => props.theme.colors.oxfordBlue};

  &:hover {
    svg {
      color: ${(props) => props.theme.colors.celticBlue};
    }
  }

  ${(props) => (0, ui_1.mq)({
    width: ['100%', '199px', '260px'],
    minHeight: ['80px', '166px'],
    padding: [`${props.theme.spacers.x3} ${props.theme.spacers.x4}`, props.theme.spacers.x3],
    boxShadow: props.theme.shadows.tertiary,
})}
`;
exports.StyledTestimonialLink = styled_components_1.default.a.withConfig({ displayName: "StyledTestimonialLink", componentId: "sc-1hx912e" }) `
  text-decoration: none;
  color: ${(props) => props.theme.colors.celticBlue};
  text-underline-offset: 5px;

  &:hover {
    text-decoration: underline;
  }
`;
